import { Controller } from "@hotwired/stimulus"

// A toolbar filter/sort menu. The trigger toggles a small radio-option menu; choosing an
// option writes the value into this dropdown's hidden field and submits the toolbar form
// (a Turbo-Frame GET), so the list re-renders with no page reload. Closes on outside-click
// or Escape.
export default class extends Controller {
  static targets = ["menu", "field"]

  connect() {
    this.closeOnOutside = this.closeOnOutside.bind(this)
    this.closeOnEscape = this.closeOnEscape.bind(this)
  }

  disconnect() {
    this.removeListeners()
  }

  toggle() {
    this.menuTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.menuTarget.hidden = false
    this.button.setAttribute("aria-expanded", "true")
    document.addEventListener("click", this.closeOnOutside)
    document.addEventListener("keydown", this.closeOnEscape)
  }

  close() {
    this.menuTarget.hidden = true
    this.button.setAttribute("aria-expanded", "false")
    this.removeListeners()
  }

  select(event) {
    // The toolbar isn't re-rendered on submit (only the inner list frame is), so move the
    // checked state to the chosen option here.
    const chosen = event.currentTarget
    this.menuTarget.querySelectorAll("[role='menuitemradio']").forEach((option) => {
      option.setAttribute("aria-checked", option === chosen ? "true" : "false")
    })
    this.fieldTarget.value = event.params.value
    this.close()
    this.element.closest("form").requestSubmit()
  }

  closeOnOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
      this.button.focus()
    }
  }

  removeListeners() {
    document.removeEventListener("click", this.closeOnOutside)
    document.removeEventListener("keydown", this.closeOnEscape)
  }

  get button() {
    return this.element.querySelector("[aria-haspopup]")
  }
}
